import img1 from "../images/airticket1.jpeg";
import img2 from "../images/airticket2.jpeg";
import img3 from "../images/airticket3.jpeg";
import img4 from "../images/airticket4.jpeg";
import img5 from "../images/airticket5.jpeg";
import img6 from "../images/airticket6.jpeg";
import SectionHeading from "./ui/SectionHeading";
import Reveal from "./ui/Reveal";

const images = [img1, img2, img3, img4, img5, img6];

const AirTickets = () => {
  return (
    <section id="airticket" className="section-pad bg-[#eef5ea]">
      <SectionHeading
        eyebrow="Fly With Us"
        title="Air Tickets"
        subtitle="Best fares on direct and connecting flights to every corner of the world."
      />
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
        {images.map((src, index) => (
          <Reveal key={index} delay={index * 0.06}>
            <div className="group overflow-hidden rounded-2xl shadow-soft">
              <img
                src={src}
                alt={`Air ticket offer ${index + 1}`}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default AirTickets;
